import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  ORDER_STATUS_LABEL,
  adminListOrders,
  formatYuan,
  isUnauthorized,
  type AdminOrder,
} from '../lib/api';
import AdminNav from './AdminNav';

export default function AdminOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<AdminOrder[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { orders: list } = await adminListOrders();
        setOrders(list);
      } catch (err) {
        if (isUnauthorized(err)) {
          navigate('/admin/login', { replace: true });
          return;
        }
        setError('订单列表加载失败');
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  return (
    <section className="stack">
      <AdminNav />
      <div className="card">
        <h2>订单管理</h2>
        <p className="muted">按创建时间倒序。点击进入详情可确认、拒绝或重试任务。</p>
        {error ? <div className="error">{error}</div> : null}
        {loading ? <p className="muted">加载中…</p> : null}
        {!loading && orders.length === 0 ? (
          <p className="muted">暂无订单</p>
        ) : null}
        {orders.length > 0 ? (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>状态</th>
                  <th>订单号</th>
                  <th>档位</th>
                  <th>金额</th>
                  <th>闲鱼单号</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id}>
                    <td>
                      <span className={`status-pill ${o.status}`}>
                        {ORDER_STATUS_LABEL[o.status] ?? o.status}
                      </span>
                    </td>
                    <td className="mono">{o.public_code}</td>
                    <td>{o.tier === 'deep' ? '深度' : '标准'}</td>
                    <td>{formatYuan(o.amount_cents)}</td>
                    <td className="mono">{o.xianyu_order_no || '—'}</td>
                    <td>
                      <Link to={`/admin/orders/${o.id}`}>详情</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </section>
  );
}
